import axios from '@/services/axios-auth-wrapper';

export default {
    getProject: id => {
        return axios.get(url + id);
    },
    getProjectsForUser: userId => {
        return axios.get(url + 'user/' + userId);
    },
    updateDraftProject: data => {
        return axios.post(url + 'savedraft', data);
    },
    updatePublishedProject: data => {
        return axios.post(url + 'savepublished', data);
    },
    updateArchivedProject: data => {
        return axios.post(url + 'savearchived', data);
    },
    publishProject: projectId => {
        return axios.post(url + 'publish/' + projectId);
    },
    republishProject: projectId => {
        return axios.post(url + 'republish/' + projectId);
    },
    createProject: data => {
        return axios.post(url + 'create', data);
    },
    copyProject: data => {
        return axios.post(url + 'copy', data);
    },
    deleteProject: projectId => {
        return axios.delete(url + projectId);
    },
    archiveProject: projectId => {
        return axios.post(url + 'archive/' + projectId);
    }
};

const url = process.env.VUE_APP_CONVERSABILITY_API_URL + '/api/project/';
